var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavIconWithBorder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_14830_163301)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.3598,
    cy: 13.3337,
    rx: 12.64,
    ry: 12.6667,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14830_163301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6935 8.23109C21.0365 6.87646 19.1437 5.76812 16.9421 6.41342C15.89 6.7187 14.9722 7.37338 14.3384 8.27049C13.7046 7.37338 12.7867 6.7187 11.7347 6.41342C9.5281 5.77797 7.64028 6.87646 6.98322 8.23109C6.06138 10.1276 6.44384 12.2605 8.12082 14.5708C9.43494 16.3786 11.313 18.211 14.0393 20.339C14.1254 20.4065 14.2316 20.4432 14.3408 20.4432C14.4501 20.4432 14.5562 20.4065 14.6424 20.339C17.3638 18.2159 19.2467 16.3983 20.5608 14.5708C22.2329 12.2605 22.6154 10.1276 21.6935 8.23109V8.23109Z",
    fill: "#EB4869"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14830_163301",
    x: 0.794848,
    y: 0.666992,
    width: 27.13,
    height: 27.1828,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.924878
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.462439
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14830_163301"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14830_163301",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14830_163301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.6524,
    height: 17.7333,
    fill: "white",
    transform: "translate(5.51172 4.46777)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavIconWithBorder);
export default __webpack_public_path__ + "static/media/favIconWithBorder.a7aae6f651bc9bd98fd8c7111dc129a2.svg";
export { ForwardRef as ReactComponent };